import React, { FC, PropsWithChildren } from 'react';
import { IOverflowSetItemProps, ProgressIndicator } from '@fluentui/react';
import { LanguageSelector } from '@eta/components';
import { connect, ConnectedProps } from 'react-redux';
import logo from '../../assets/img/logo.png';
import Footer from '../layout/Footer';

import './UserLayoutContent.scss';
import { ReduxState } from '../reducers';
import { isEmptyText } from '../../helpers/utils';

export interface LayoutContentProps {
    className?: string;
    contentClassName?: string;
    title?: string | string[];
    hideHeader?: boolean;
    loading?: boolean;
    commandButtons?: IOverflowSetItemProps[];
}

const mapDispatchToProps = {    
};

const mapStateToProps = (state: ReduxState) => ({
    currentLang: state.reduxlanguage.language,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const UserLayoutContent: FC<PropsWithChildren<LayoutContentProps> & PropsFromRedux> = (
    props: PropsWithChildren<LayoutContentProps> & PropsFromRedux
) => {
    const { loading, children, currentLang } = props;
    
    const isRtlLanguage = (): boolean => {
        if(isEmptyText(currentLang.lang))
            return localStorage.getItem('i18nextLng') === 'ar';
        return currentLang.isRtl;
    };
    
    return (
        <>
            <div className="userLayout">
                <LanguageSelector />
                <div className="logo">
                    <img className="test" src={logo} alt="Logo" />
                </div>
                {loading && <ProgressIndicator />}
                {!loading && <div className="LoadingIndicator" />}
                <div dir={isRtlLanguage() ? 'rtl' : 'ltr'} className="container">{children}</div>
            </div>
            <Footer />
        </>
    );
};

export default connector(UserLayoutContent);